import React from "react";
import { Link } from "react-router-dom";

import "./Info.css";
import InfoItem from "./Infoitem";

function Info() {
  return (
    <div className="cards_info">
      <h1>OUR SERVICES</h1>
      <div className="cards__container_info">
        <div className="cards__wrapper_info">
          <ul className="cards__item_info">
            <InfoItem
              path="/contact"
              src="images/img-20.jpg"
              text="We are an audio-visual 
                        production company that provides services of video recording, 
                   editing, photography and marketing promo materials. For over 15 years, we have 
                   successfully delivered content creation. 
                   With passion and enthusiasm, we deliver flawless performance. 
                   We truly love what we do and love helping our clients achieve the desired effect for their projects."
              label="Services Info"
            />
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Info;
